export const enum SendStatus {
    // All items successfully sent to manufacturer
    sent = 'sent',
    // Sending to manufacturer not attempted
    notSent = 'not-sent',
    // Error occurred when sending items
    failedToSend = 'failed-to-send',
  };
  